module.exports = __webpack_public_path__ + "img/BannerCV1920x600px.6e5ff47f.jpg";